import Vue from 'vue';
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import store from './store/';
// import VeeValidate, { Validator } from 'vee-validate';
import './registerServiceWorker';
import VueCarousel from 'vue-carousel';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowLeft,
  faArrowRight,
  faPlane,
  faCheck,
  faPlaneArrival,
  faPlaneDeparture,
  faArrowsAltH,
  faUserAlt,
  faHotel,
  faCalendar,
  faUser,
  faBus,
  faParachuteBox,
  faSnowboarding,
  faSearch,
  faSuitcase,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import './assets/override.scss';
import './assets/_fonts.scss';

import BootstrapVue from 'bootstrap-vue';
// import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import Multiselect from 'vue-multiselect'

library.add(
  faArrowLeft,
  faArrowRight,
  faPlane,
  faCheck,
  faPlaneArrival,
  faArrowsAltH,
  faPlaneDeparture,
  faUserAlt,
  faHotel,
  faCalendar,
  faUser,
  faBus,
  faParachuteBox,
  faSnowboarding,
  faSearch,
  faSuitcase,
);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('multiselect', Multiselect);
Vue.use(VueCarousel);
Vue.config.productionTip = false;

locale.use(lang);
Vue.use(Element);
Vue.use(BootstrapVue);
// Validator.localize('th', th);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
